import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import Router from 'vue-router'
import 'normalize.css'
import './style/index.scss'
import './run.init.js'
import store from './store/index.js'
import './tools/index.js'
// import 'light-ui-m/library/common.css'
// import LightUI from 'light-ui-m'
// import 'light-ui-m/library/light.css'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import 'ant-design-vue/dist/antd.less'
import Request from './tools/request'
import vconsole from 'vconsole'
import { message, Modal } from 'ant-design-vue'
// new vconsole()
if (process.env.VUE_APP_env != 'prd') {
  new vconsole()
}

Vue.use(Router)
Vue.use(Antd)
// Vue.use(LightUI, {
//   dependence: {
//     router,
//     store
//   }
// })

Vue.prototype.$request = new Request()

Vue.prototype.$modal = Modal
Vue.prototype.$message = message

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    !!navigator.userAgent.match(/iphone/i) &&
      (document.body.className = 'webapp-device-ios')
  }
}).$mount('#app')
